
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import steamService from '@/services/steam.service';

  import { IConnectModel } from "@/models/account.model";

  @Component({
    computed: {
      ...mapGetters([
        'token',
        'user',
        'connects'
      ])
    }
  })
  export default class SteamUnlink extends Vue {
    created() {
      this.$store.watch(() => this.$store.getters.token, token => {
        this.$store.watch(() => this.$store.getters.connects, connects => {
          const steamConnect: IConnectModel = this.$store.getters.connects.find((connect: IConnectModel) => connect.CanonicalName == "steam" && connect.IsLinked == true);

          if (steamConnect != null) {
            steamService.unlinkSteam(this, token, steamConnect.Id_Account);
          } else if (this.$store.getters.redirectUrl != null) {
            window.location.href = this.$store.getters.redirectUrl;
          }
        });
      })
    }
  }
